import { RouterModule, Routes } from "@angular/router";

import { HomeComponent } from "./home";
import { LoginComponent } from "./login";
import { RegisterComponent } from "./register";
import { HousingComponent } from "./housing";
import { ForgotPasswordComponent } from "./forgotPassword";
import { ResetPasswordComponent } from "./resetPassword";
import { AuthGuard } from "./_guards";
import { AdmissionsComponent } from "./admissions";
import { OrientationComponent } from "./orientation";
import { PermitToStayComponent } from "./permitToStay";

const appRoutes: Routes = [
    { path: "", component: HomeComponent, canActivate: [AuthGuard] },
    { path: "login", component: LoginComponent },
    { path: "register", component: RegisterComponent },
    { path: "register/:program", component: RegisterComponent },
    { path: "forgotPassword", component: ForgotPasswordComponent },
    { path: "resetPassword", component: ResetPasswordComponent },
    { path: "housing", component: HousingComponent, canActivate: [AuthGuard], data: { requiredProperties: ["canApplyForHousing"] } },
    { path: "admissions", component: AdmissionsComponent, canActivate: [AuthGuard], data: { requiredProperties: ["canApplyForAdmissions"] } },
    { path: "orientation", component: OrientationComponent, canActivate: [AuthGuard], data: { requiredProperties: ["canViewOrientation"] } },
    { path: "immigration", component: PermitToStayComponent, canActivate: [AuthGuard], data: { requiredProperties: ["canViewImmigration"] } },

    // otherwise redirect to home
    { path: "**", redirectTo: "" }
];

export const appRouting = RouterModule.forRoot(appRoutes);